import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Search, BarChart3, Target, LineChart, ArrowUpRight } from 'lucide-react';
export function Framework() {
  const steps = [{
    number: '01',
    icon: <Search className="w-5 h-5" data-id="element-83" />,
    title: 'Diagnose',
    description: 'Identify operational gaps, ecosystem barriers, and growth blockers.'
  }, {
    number: '02',
    icon: <BarChart3 className="w-5 h-5" data-id="element-84" />,
    title: 'Align & Understand Analytics',
    description: 'Align strategy with data-driven business intelligence.'
  }, {
    number: '03',
    icon: <Target className="w-5 h-5" data-id="element-85" />,
    title: 'Execute',
    description: 'Implement strategic infrastructure and operational improvements.'
  }, {
    number: '04',
    icon: <LineChart className="w-5 h-5" data-id="element-86" />,
    title: 'Measure & Adjust',
    description: 'Track measurable outcomes and refine for impact.'
  }, {
    number: '05',
    icon: <ArrowUpRight className="w-5 h-5" data-id="element-87" />,
    title: 'Advance',
    description: 'Scale into sustainable economic advancement.'
  }];
  return <section id="framework" className="py-24 lg:py-40 bg-deep-azure text-white relative overflow-hidden" data-id="element-88">
      {/* Layered ocean background */}
      <div className="absolute inset-0 bg-ocean-radial" data-id="element-89"></div>
      <div className="absolute inset-0 ocean-pattern opacity-40" data-id="element-90"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-[40%] bg-azure/10 blur-[140px] rounded-full" data-id="element-91"></div>
      <div className="absolute bottom-0 right-0 w-[40%] h-[60%] bg-golden-yellow/5 blur-[140px] rounded-full" data-id="element-92"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-93">
        <FadeIn className="text-center max-w-3xl mx-auto mb-24" data-id="element-94">
          <p className="text-[11px] font-semibold tracking-[0.4em] uppercase text-golden-yellow mb-8" data-id="element-95">
            Methodology
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-medium leading-[1.1] mb-6 tracking-tight" data-id="element-96">
            The{' '}
            <em className="italic font-light text-golden-yellow" data-id="element-97">
              Changing Optics
            </em>{' '}
            Framework™
          </h2>
          <p className="text-lg text-white/70 leading-relaxed font-light" data-id="element-98">
            A measurable, strategic process designed to move women founders from
            operational bottlenecks to sustainable economic advancement.
          </p>
          <div className="editorial-rule w-32 mx-auto mt-10" data-id="element-99"></div>
        </FadeIn>

        {/* Framework — horizontal connected flow */}
        <div className="relative" data-id="element-100">
          {/* Glowing connecting line */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-azure/60 to-transparent z-0" data-id="element-101">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-azure to-transparent blur-sm" data-id="element-102"></div>
          </div>

          <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4 relative z-10" data-id="element-103">
            {steps.map((step, index) => <StaggerItem key={index} className="flex flex-col items-center text-center group" data-id="element-104">
                {/* Numbered orb */}
                <div className="relative mb-8" data-id="element-105">
                  <div className="w-24 h-24 rounded-full glass-card flex items-center justify-center relative group-hover:border-azure/40 transition-all duration-500" data-id="element-106">
                    <div className="absolute inset-0 rounded-full bg-azure/5 blur-xl group-hover:bg-azure/15 transition-all duration-500" data-id="element-107"></div>
                    <div className="relative z-10 flex flex-col items-center justify-center" data-id="element-108">
                      <span className="font-display italic text-3xl text-golden-yellow leading-none mb-1" data-id="element-109">
                        {step.number}
                      </span>
                      <div className="text-azure" data-id="element-110">{step.icon}</div>
                    </div>
                  </div>
                </div>

                <h3 className="text-xl font-display font-medium text-white mb-3 tracking-tight" data-id="element-111">
                  {step.title}
                </h3>
                <p className="text-sm text-white/60 leading-relaxed font-light px-2" data-id="element-112">
                  {step.description}
                </p>
              </StaggerItem>)}
          </StaggerContainer>
        </div>
      </div>
    </section>;
}